import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import Bird, { FLIGHT_ENDED } from '../animations/Bird';
import Cup from '../game/Cup';
import CupStack from '../game/CupStack';
import gameData from '../gameData';
import Keyboard from '../keyboard/Keyboard';
import SoundAssetKeys from '../SoundAssetKeys';
import StackGameButton from '../ui/StackGameButton';
import Game from './Game';
import { getGameBackground } from './GameBackground';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';
import FontKeys from '../FontKeys';

export default class Instructions extends Phaser.Scene
{
    static get KEY() { return 'Instructions'; }

    constructor()
    {
        super({ key: (Instructions).KEY });
    }

    create()
    {
        /** @type {Cup[]} */
        this.cupsAdded = [];
        this.instDismissed = false;

        const instructionsBg = this.add.graphics({fillStyle: {color: 0xf8dcbc}, x: -327, y: -156}).fillRoundedRect(0,0,655, 312, 10).fillStyle(0xf3b98c).fillRoundedRect(8,8,655-16, 312-16, 10);
        const instructionsText = ABCyaPhaser.Text.addText(0,-90,80, 0xfcfdff, FontKeys._odin_roundedregular, ABCyaPhaser.Localization.instance.getLocalizedString("instructions_popup.header"), this);
        this.instDisplay = this.add.container(this.scale.width / 2, 0, [
          instructionsBg,
          instructionsText,
          ABCyaPhaser.Text.addText(0,48,26, 0x704934, FontKeys._odin_roundedregular, ABCyaPhaser.Localization.instance.getLocalizedString("instructions_popup.text"), this).setWordWrapWidth(475)
        ]).setSize(655, 312);
        // add the white line under the "INSTRUCTIONS" text
        instructionsBg.fillStyle(0xfcfafb).fillRoundedRect(instructionsText.x - instructionsText.width/2 - instructionsBg.x, instructionsText.y + instructionsText.height/2-instructionsBg.y-6, instructionsText.width, 5, 2);

        this.instDisplay.scale = 0.8;
        this.instDisplay.y = -(this.instDisplay.height / 2);

        this.miniKeys = new Keyboard(this, gameData.isMobile ? this.scale.width / 2 : this.scale.width * 0.3, 0, true);
        this.miniKeys.scale = 0.75;
        this.miniKeys.controlKeysShown(true);

        this.introStack = this.createIntroCupStack();

        this.bird = new Bird(this, 0, 0);
        this.bird.x = -(this.bird.body.width + 50);
        this.bird.on(FLIGHT_ENDED, this.finishFlight.bind(this));

        this.goBtn = new StackGameButton(this, this.scale.width / 2, 0, {text: ABCyaPhaser.Localization.instance.getLocalizedString("play_button")});
        let bottomOffset = gameData.isMobile ? -10 : 0;
        this.goBtn.y = this.scale.height - (this.goBtn.height / 2) - bottomOffset;
        this.goBtn.alpha = 0;

        this.startInstructions();
    }

    startInstructions()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._basket_menu_tween, this);
        let instEndY = gameData.isMobile ? (this.instDisplay.height / 2) + 100 : (this.instDisplay.height / 2) + 25;
        ABCyaPhaser.Tweens.addTween(this.instDisplay, 500, { y: instEndY }, Phaser.Math.Easing.Quadratic.Out, this.instructionsReady.bind(this));
    }

    instructionsReady()
    {
        let stackColors = ["red", "blue", "yellow"];
        this.introStack.stackReady = true;
        // this was the original position of the blanket before it was baked into the grass graphic
        const introStackYPos = gameData.isMobile ? (this.scale.height / 2) + 170 : this.scale.height - 75;
        this.introStack.initStack(gameData.isMobile ? (this.scale.width / 2 + 100) : (this.scale.width / 2 + 150), introStackYPos - 40, stackColors[Phaser.Math.Between(0, stackColors.length - 1)]);
        //get array of letter after scramble
        //get steps from stack array;
        this.introStackLetters = [];
        for (let i = 0; i < this.introStack.stackPositions.length; i++)
        {
            for (let j = 0; j < this.introStack.stackPositions[i].length; j++)
            {
                this.introStackLetters.push(this.introStack.stackPositions[i][j]._positionId);
            }
        }

        this.instSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
        ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._cup_stack_instructions, this.instSound);
        this.goBtn.popIn();
        this.goBtn.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.dismissInstructions, this);
        this.startDemo();
    }

    startDemo()
    {
        this.stackIndex = 0;
        this.stacking = true;
        this.flyToKey();
    }

    flyToKey()
    {
        if (this.instDismissed) return;
        //fly bird to each key and stack and unstack with each hit
        //get position of key
        let key = this.miniKeys.getKeyByValue(this.introStackLetters[this.stackIndex]);
        //fly bird to key
        this.bird.jumpTo(this.miniKeys.x + (key.x * this.miniKeys.scaleX) - (this.bird.body.width / 2), this.miniKeys.y + (key.y * this.miniKeys.scaleY) - (this.bird.body.height) + 30, 700);
    }

    finishFlight()
    {
        if (this.stackIndex >= 0 && !this.instDismissed)
        {
            let key = this.miniKeys.getKeyByValue(this.introStackLetters[this.stackIndex]);
            key.showKeyPress(true);
            this.introStack.inputToStackPosition(this.introStackLetters[this.stackIndex].toString());
            this.time.delayedCall(500, this.toNext, null, this);
            //move above cups
            this.children.bringToTop(this.bird);
        }
    }

    toNext()
    {
        if (this.instDismissed == false)
        {
            let key = this.miniKeys.getKeyByValue(this.introStackLetters[this.stackIndex]);
            key.showKeyPress(false);

            if (this.stacking)
            {
                this.stackIndex++;
                if (this.stackIndex < this.introStackLetters.length)
                {
                    // do nothing
                }
                else
                {
                    this.stackIndex = this.introStackLetters.length - 1;
                    this.stacking = false;
                }
                this.flyToKey();
            }
            else
            {
                this.stackIndex--;
                if (this.stackIndex < 0)
                {
                    //clear cups and start again
                    while (this.cupsAdded.length > 0)
                    {
                        let cup = this.cupsAdded.shift();
                        cup.spinOff("left");
                    }
                    if (!gameData.isMobile)
                    {
                        this.bird.flyTo(this.scale.width - this.bird.getBounds().width - 100, getGameBackground().horizon - this.bird.getBounds().height + 20, 1500);
                    }
                    else
                    {
                        this.bird.flyTo(80, this.scale.height / 2, 1500);
                    }

                    this.time.delayedCall(2000, this.startDemo, null, this);
                    this.introStack.resetStack();
                }
                else
                {
                    this.flyToKey();
                }
            }
        }
    }

    dismissInstructions()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

        this.time.removeAllEvents();
        this.bird.killTweens();
        this.tweens.killTweensOf(this.goBtn);

        this.instSound.destroy();
        this.instSound = null;
        this.instDismissed = true;
        this.goBtn.popOut();
        this.introStack.hideStackOutline();
        ABCyaPhaser.Tweens.addTween(this.instDisplay, 500, { y: -this.instDisplay.height }, Phaser.Math.Easing.Quadratic.Out);
        this.miniKeys.controlKeysShown(false);
        this.bird.removeAllListeners();
        //bird fly off and up
        this.bird.flyTo(this.scale.width + 100, -100, 900);
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._bird_jump_fly_tween, this);
        while (this.cupsAdded.length > 0)
        {
            let cup = this.cupsAdded.shift();
            cup.spinOff("right");
        }

        this.time.delayedCall(500, () =>
        {
            this.time.delayedCall(500, this.goToGame, null, this);
        });
    }

    createIntroCupStack()
    {
        let colors = ["red", "blue", "yellow"];
        let stack = new CupStack(this, 0, 0, ["w", "h", "d"], this, colors[Phaser.Math.Between(0, colors.length - 1)]);
        return stack;
    }

    goToGame()
    {
        getGameBackground().pan("stop");

        this.scene.start(Game.KEY);
    }
}